/**
 * A receipt photo taken before the add-record form opened (phones only open the camera inside the tap
 * itself, so "scan receipt" buttons elsewhere take the photo first), handed to the form that opens next.
 */
let stashed: { file: File; at: number } | null = null;

export function stashReceiptPhoto(file: File) {
  stashed = { file, at: Date.now() };
}

export function takeStashedPhoto() {
  const s = stashed;
  stashed = null;
  return s && Date.now() - s.at < 60_000 ? s.file : null;
}
